import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Grid, Popup, Icon, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  removeElementFromChassis,
  removeElementFromParts,
  removeElementFromTasks,
  removeElementFromProviderManualOrder,
} = Actions;

const elementType = {
  'chassis': 'el chasis',
  'partsArray': 'la parte',
  'partsOrders': 'la orden de parte',
  'tasksArray': 'la tarea',
};

const DeleteIcon = ({index, data, campaingNo, dataType}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDeleteClick = () => {
    if (dataType === 'chassis') {
      const requestData = [{[dataType]: data}];
      dispatch(removeElementFromChassis(campaingNo, requestData, index));
    } else if (dataType === 'partsArray') {
      dispatch(removeElementFromParts([data]));
    } else if (dataType === 'partsOrders') {
      dispatch(removeElementFromProviderManualOrder(index));
    } else {
      dispatch(removeElementFromTasks([data]));
    }
    handleClose();
  };

  return (
    <Popup
      wide
      inverted
      on='click'
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={<Icon link color='red' size='big' name='delete' />}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign='center'>
            <div>{`¿Desea eliminar ${elementType[dataType]}?`}</div>
            <Button secondary size='mini' onClick={handleClose}>
              CANCELAR
            </Button>
            <Button primary size='mini' onClick={handleDeleteClick}>
              ELIMINAR
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Popup>
  );
};

export default DeleteIcon;
